import { useState, useEffect } from 'react';
import api from '../api'; 

export const usePushNotifications = () => {
  const [isSupported, setIsSupported] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      setIsSupported(true);
      checkSubscriptionStatus(); // Check status on mount
    }
  }, []);

  // Helper to check if we are already subscribed
  const checkSubscriptionStatus = async () => {
    try {
      const register = await navigator.serviceWorker.ready;
      const sub = await register.pushManager.getSubscription();
      setIsSubscribed(!!sub); // Convert to boolean
    } catch (err) {
      console.error('Error checking subscription status:', err);
    }
  };

  const subscribeToPush = async () => {
    if (!isSupported) return alert("Push notifications not supported");

    try {
      // 1. Get VAPID Public Key from backend
      const res = await api.get('/notifications/vapid-public-key');
      const vapidPublicKey = res.data.publicKey;
      
      // 2. Convert key to Uint8Array
      const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

      // 3. Register Push
      const registration = await navigator.serviceWorker.ready;
      const newSubscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: convertedVapidKey
      });

      // 4. Send subscription to backend
      await api.post('/notifications/subscribe', newSubscription.toJSON());

      setIsSubscribed(true);
      alert("Successfully subscribed to notifications!");
      
    } catch (err) {
      console.error("Failed to subscribe:", err);
      alert("Failed to enable notifications.");
    }
  };

  const unsubscribeFromPush = async () => {
    if (!isSupported) return;

    try {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.getSubscription();
      
      if (subscription) {
        // 1. Unsubscribe from the push service (browser level)
        await subscription.unsubscribe();
        
        // 2. ✅ NOTIFY BACKEND to remove the subscription from the database
        // This prevents the server from trying to send pushes to invalid endpoints
        await api.post('/notifications/unsubscribe');

        setIsSubscribed(false);
        alert("Notifications disabled.");
      } else {
        setIsSubscribed(false);
      }
    } catch (err) {
      console.error("Failed to unsubscribe:", err);
      alert("Failed to disable notifications.");
    }
  };

  return { isSupported, isSubscribed, subscribeToPush, unsubscribeFromPush };
};

// Helper function for VAPID key conversion
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}